import { FC } from 'react';

import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

interface ToolInfoMarkProps {
  id: string;
  icon: string;
  labels: [string, string?];
}

export const ToolInfoLabeledMark: FC<ToolInfoMarkProps> = ({ id, icon, labels }) => (
  <div data-testid={id}>
    <PhoenixIcon icon={getDesignSystemIcon(icon)} className="mr-2 inline h-4 w-4 text-green" />
    <span className="mr-1 mt-1 stihl-text-body-default-bold">{labels[0]}</span>
    {labels[1] && <span className="stihl-text-body-default-reg">{labels[1]}</span>}
  </div>
);
